var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "41px",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    fill: "#E3E3E3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 20.428571) rotate(-90.000000) translate(-32.000000, -20.428571) translate(12.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2141819,0.000793806149 C31.8725618,0.000793806149 33.4661771,0.662298931 34.7410694,1.91810025 C37.2260894,4.49691182 37.2260894,8.73226451 34.7410694,11.3108115 L15.425814,31.4218902 L34.8029017,51.530323 C37.2879217,54.1091345 37.2879217,58.3444874 34.8029017,60.9230343 C32.3178817,63.5018457 28.236569,63.5018457 25.751804,60.9230343 L1.84757388,36.1192381 C0.637446137,34.8634368 0,33.2096739 0,31.4214933 C0,29.6359587 0.702210663,27.9821959 1.84757388,26.7237486 L25.6893342,1.91730645 C26.9642265,0.66150512 28.6201203,0 30.2137357,0 L30.2141819,0.000793806149 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e5b2a3f785df67075d5b4a4925aed2ae.svg";
export { ForwardRef as ReactComponent };